export function shouldShowHlsJsPlaybackFailure(errorData) {
  return errorData?.fatal === true;
}

export function isMuxPlaybackStartupSuccessEvent(eventType) {
  return eventType === "loadedmetadata" || eventType === "playing";
}

export function isNativeMuxPlaybackFailureEvent(eventType) {
  return eventType === "error";
}
